var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVaknlLgTravelers = function SvgVaknlLgTravelers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F3AD05",
    fillRule: "nonzero",
    d: "M25.059 11.509c-1.988 0-3.659-.388-3.659 1.6v.9h7.2v-.9c0-1.988-1.553-1.6-3.541-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M31 26.479v.5c0 .168-.02.336-.06.5a2 2 0 0 1-1.94 1.5h-8a2 2 0 0 1-1.94-1.5 2.11 2.11 0 0 1-.06-.5v-.5c-.003-.13.003-.26.02-.39a5.944 5.944 0 0 1 1.74-3.85 6.45 6.45 0 0 1 2.43-1.48 5.995 5.995 0 0 1 3.62 0c.472.15.923.362 1.34.63a5.942 5.942 0 0 1 2.83 4.7c.017.13.023.26.02.39h0zm-2.5-12a.337.337 0 0 1-.01.1 3.501 3.501 0 0 1-3.542 3.27 3.502 3.502 0 0 1-3.448-3.371 2.514 2.514 0 0 1 .05-.54 3.48 3.48 0 0 1 2.59-2.85c.28-.073.57-.11.86-.11a3.5 3.5 0 0 1 3.5 3.5h0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3AD05",
    fillRule: "nonzero",
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M26 26.981v-.5a6.018 6.018 0 0 0-6-6h0a6.018 6.018 0 0 0-6 6v.5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M23.5 14.479a.337.337 0 0 1-.01.1 3.501 3.501 0 0 1-3.542 3.27 3.502 3.502 0 0 1-3.448-3.371 2.514 2.514 0 0 1 .05-.54 3.48 3.48 0 0 1 2.59-2.85c.28-.073.57-.11.86-.11a3.5 3.5 0 0 1 3.5 3.5h0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18.5 14.479a.337.337 0 0 1-.01.1 3.501 3.501 0 0 1-3.542 3.27 3.502 3.502 0 0 1-3.448-3.371 2.514 2.514 0 0 1 .05-.54 3.48 3.48 0 0 1 2.59-2.85c.28-.073.57-.11.86-.11a3.5 3.5 0 0 1 3.5 3.5h0zm2.5 12.25h0c0 .69-.56 1.25-1.25 1.25h-9.5c-.69 0-1.25-.56-1.25-1.25v-.25c0-1.718.735-3.353 2.02-4.493a6.005 6.005 0 0 1 4.704-1.465A6.167 6.167 0 0 1 21 26.729h0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3D9B8B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.975 10.979a3.018 3.018 0 0 1-3 3 2.262 2.262 0 0 1-.45-.04 3.48 3.48 0 0 1 2.59-2.85c.28-.073.57-.11.86-.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.475 14.479a.337.337 0 0 1-.01.1 3.02 3.02 0 0 1-1.49.4 3.013 3.013 0 0 1-3-3c0-.302.047-.602.14-.89.28-.073.57-.11.86-.11a3.5 3.5 0 0 1 3.5 3.5z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18.5 14.521a.337.337 0 0 1-.01.1 3.501 3.501 0 0 1-3.542 3.27A3.502 3.502 0 0 1 11.5 14.52a2.514 2.514 0 0 1 .05-.54 3.48 3.48 0 0 1 2.59-2.85c.28-.073.57-.11.86-.11a3.5 3.5 0 0 1 3.5 3.5h0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#282828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M21 27.024v-.5a6.018 6.018 0 0 0-6-6h0a6.018 6.018 0 0 0-6 6v.5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2z"
  }))));
};
export default SvgVaknlLgTravelers;